// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ZPzd","left":"styles_left__2bVnw"};